import React, {useMemo} from 'react'
import type {ElementShapeType} from '../../../entities/project'
import type {NodeConfig} from 'konva/lib/Node'
import {CanvasEditor, CanvasEditorProps} from '../CanvasEditor'
import {canvasElementsRegistry} from '../elements/CanvasElementsRegistry'
import {DraggableElementLayer} from '../visualLayers/DraggableElementLayer'

export type ToolType = ElementShapeType | null

export type CanvasToolManagerProps = {
  tool: ToolType
  onElementDrawn: (shape: {type: ElementShapeType; props: NodeConfig}) => void
  canvasEditorProps: CanvasEditorProps
}

export type ToolPreviewState = {}

export function CanvasToolManager(props: CanvasToolManagerProps) {
  const elementRegistryInfo = useMemo(() => canvasElementsRegistry[props.tool], [props.tool])

  const {toolCursor = 'crosshair', toolLayer: ToolLayerComponent} = elementRegistryInfo || {}

  let toolLayer: React.ReactNode = ToolLayerComponent ? (
    <ToolLayerComponent onElementDrawn={props.onElementDrawn} />
  ) : null

  return (
    <div style={{position: 'relative', height: '100%'}}>
      {props.tool && (
        <div
          style={{
            position: 'absolute',
            top: 0,
            right: 0,
            background: 'rgba(0, 0, 0, 0.2)',
            padding: '4px 8px',
          }}
        >
          {props.tool}
        </div>
      )}
      <CanvasEditor
        {...props.canvasEditorProps}
        toolLayer={toolLayer}
        toolCursor={toolCursor}
        onDragEnd={(x, y, width, height) => {
          props.onElementDrawn({
            type: 'image',
            props: {
              x: Math.floor(x),
              y: Math.floor(y),
              width: Math.floor(width),
              height: Math.floor(height),
            },
          })
        }}
      ></CanvasEditor>
    </div>
  )
}
